import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SortDescriptor } from '@progress/kendo-data-query';
import { ColumnEvents } from '@veritas-dumpsters/constants/column-events.const';
import { VeritasMessage } from '@veritas-dumpsters/models/dumpster-event-detail';
import { DumpsterEventsOutputItem } from '@veritas-dumpsters/models/dumpster-events';
import { DumpsterService } from '@veritas-dumpsters/services/dumpster.service';
import { DEFAULT_SORTING } from '@veritas-shared/constants/kendo/config-const';
import { ConstantHelper } from '@veritas-shared/helpers/constant.helper';
import { EntityListOutput } from '@veritas-shared/models/entities/entity-list-output';
import { GridColumn } from '@veritas-shared/models/grid-column';
import { BeanDialogDimension, BeanKendoDialogService, WindowContainerDimension, WindowVisualizerDirective } from 'bean-kendo-dialog';
import { DumpsterEventDetailDialogComponent } from '../dumpster-event-detail-dialog/dumpster-event-detail-dialog.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-detail-events',
  templateUrl: './detail-events.component.html',
  styleUrls: ['./detail-events.component.scss']
})
export class DetailEventsComponent implements OnInit, OnDestroy {
  @ViewChild(WindowVisualizerDirective, { static: true })
  public windowVisualizer: WindowVisualizerDirective;

  public eventsColumns: GridColumn[] = [];
  public eventsDefaultSort: SortDescriptor = DEFAULT_SORTING;

  private eventDetail$ = new Subscription();

  @Input() public entities: EntityListOutput = {} as EntityListOutput;
  @Input() public events: DumpsterEventsOutputItem[] = [];

  constructor(
    private constantHelper: ConstantHelper,
    private dumpsterService: DumpsterService,
    private dialogService: BeanKendoDialogService,
    private translate: TranslateService,
  ) { }

  ngOnDestroy(): void {
    this.eventDetail$.unsubscribe();
  }

  ngOnInit(): void {
    this.setTable();
  }

  private setTable = () => {
    const config = new ColumnEvents(this.constantHelper);
    this.eventsColumns = [
      config.payloadType(this.setDetailOpen),
      config.timestamp(),
      config.messageType()
    ];
  }

  private setDetailOpen = (event: DumpsterEventsOutputItem): void => {
    this.eventDetail$ = this.dumpsterService
      .getDumpsterEventDetail({
        service: event.service,
        supplier: event.supplier,
        entityId: event.entityId,
        id: event.id,
      })
      .subscribe((event: VeritasMessage) => {
        this.setOpenModal(event);
      });
  }

  private setOpenModal = (event: VeritasMessage): void => {
    if (!event) return;
    this.dialogService.openDialog(
      this.translate.instant('page.CommandEventDetail.Title'),
      { event, payloadTypes: this.entities?.payloadTypes, wasteTypes: this.entities?.wasteTypes },
      DumpsterEventDetailDialogComponent,
      this.windowVisualizer,
      () => {},
      null,
      true,
      WindowContainerDimension.Medium
    );
  }
}
